import * as actionTypes from 'store/user/actionTypes';

import { UserStore } from 'types/store/userStore';
import { SagaActionsProps } from 'types/commonInterfaces';
import { ChangePasswordRequest, BaseSendEmailRequest, UpdateUserRequest } from './types';

export const getCurrentUserRequest = (payload?: SagaActionsProps) => {
  return { type: actionTypes.GET_CURRENT_USER_REQUEST, payload } as const;
};

export const getCurrentUserSuccess = (payload: UserStore) => {
  return { type: actionTypes.GET_CURRENT_USER_SUCCESS, payload } as const;
};

export const getCurrentUserError = (payload: Error) => {
  return { type: actionTypes.GET_CURRENT_USER_ERROR, payload } as const;
};

export const updateUserEmail = (payload: BaseSendEmailRequest) => {
  return { type: actionTypes.UPDATE_USER_EMAIL, payload } as const;
};

export const updateUserRequest = (payload: UpdateUserRequest) => {
  return { type: actionTypes.UPDATE_USER_REQUEST, payload } as const;
};

export const updateUserSuccess = (payload: UserStore) => {
  return { type: actionTypes.UPDATE_USER_SUCCESS, payload } as const;
};

export const updateUserError = (payload: Error) => {
  return { type: actionTypes.UPDATE_USER_ERROR, payload } as const;
};

export const forgotPasswordRequest = (payload: BaseSendEmailRequest) => {
  return { type: actionTypes.FORGOT_PASSWORD_REQUEST, payload } as const;
};

export const forgotPasswordSuccess = (payload: UserStore) => {
  return { type: actionTypes.FORGOT_PASSWORD_SUCCESS, payload } as const;
};

export const forgotPasswordError = (payload: Error) => {
  return { type: actionTypes.FORGOT_PASSWORD_ERROR, payload } as const;
};

export const changePasswordRequest = (payload: ChangePasswordRequest) => {
  return { type: actionTypes.CHANGE_PASSWORD_REQUEST, payload } as const;
};

export const changePasswordSuccess = () => {
  return { type: actionTypes.CHANGE_PASSWORD_SUCCESS } as const;
};

export const changePasswordError = (payload: Error) => {
  return { type: actionTypes.CHANGE_PASSWORD_ERROR, payload } as const;
};

export const resetUserData = () => {
  return { type: actionTypes.RESET_USER_DATA } as const;
};

export function setIsCloseInformationModal(status: boolean) {
  return { type: actionTypes.SET_IS_CLOSE_INFORMATION_MODAL, payload: status } as const;
}

export function setUrlParams(url: { [key: string]: string } | null) {
  return { type: actionTypes.SET_URL_PARAMS, payload: url } as const;
}
